import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, UrlTree } from "@angular/router";
import { AccountService } from "app/shared/services/account.service";
import { UrbanSitterService } from "app/shared/services/urban-sitter.service";
import { Observable, of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class UrbanSitterGuard {
  constructor(
    private accountService: AccountService,
    private router: Router,
    public urbanSitterService: UrbanSitterService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (route.queryParams.token && route.queryParams.id) {
      return true;
    }
    const isLogged = this.checkIfLogged();
    if (route.queryParams.urbanSitter && isLogged) {
      return this.accountService.getHeartbeat().pipe(
        map((res) => {
          return this.router.createUrlTree(["loading-state"], {
            queryParams: route.queryParams,
          });
        }),
        catchError(() => of(true)),
      );
    }
    return true;
  }

  private checkIfLogged() {
    return !(this.accountService.getLogged() instanceof Error);
  }
}
